import {Component, computed, effect, input} from '@angular/core';
import {ParticipantTotalScore, StablefordTotalScore, StrokePlayTotalScore, TotalScoreType} from "../../../model/total-score";
import {ScoringMethodType} from "../../../model/scoring-method";
import {HandicapMode} from "../../../../model/round";

@Component({
    selector: 'total-score',
    templateUrl: './total-score.component.html',
    imports: [],
    styleUrls: ['./total-score.component.css']
})
export class TotalScoreComponent {
    total = input.required<ParticipantTotalScore>();

    value = computed(() => {
        let score = this.total().score
        switch (score.type) {
            case TotalScoreType.StrokePlayScore:
                return (score as StrokePlayTotalScore).value?.toString() ?? "-"
            case TotalScoreType.StablefordScore:
                return (score as StablefordTotalScore).points?.toString() ?? "-"
            case TotalScoreType.Unavailable:
                return "-"
        }
    });

    label = computed(() => {
        switch (this.total().method.type) {
            case ScoringMethodType.StrokePlay:
                return (this.total().handicapMode == HandicapMode.Gross) ? "Gross" : "Net";
            case ScoringMethodType.Stableford:
                return "Points";
        }
    });
}
